<template>
  <div class="home">
    <div class="left" :class="this.$store.state.showContent ? 'left-a' : ''">
      <!--环境信息-->
      <div class="environmental">
        <div class="title-box">
          <div class="environmental-cont"></div>
          <div class="title">环境信息</div>
          <div class="title-right"></div>
        </div>
        <div class="time-box">
          <div class="time">10：30：42</div>
          <div class="line"></div>
          <div class="date">2020-03-09</div>
          <div class="line"></div>
          <div class="week">星期二</div>
        </div>
        <div class="weather">
          <div class="rain">
            <div class="icon"></div>
            <div class="text">小雨</div>
            <div class="textwd">20-23℃</div>
          </div>
          <div class="rain-line"></div>
          <div class="rain-right">
            <ul>
              <li>
                <span>降雨概率</span>
                <span>16%</span>
              </li>
              <li>
                <span>湿度</span>
                <span>52%</span>
              </li>
              <li>
                <span>风速</span>
                <span>12KM/h</span>
              </li>
              <li>
                <span>气压</span>
                <span>2021.1mb</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--数据概览-->
      <div class="dataOverview">
        <div class="title-box">
          <div class="dataOverview-cont"></div>
          <div class="title">数据概括</div>
          <div class="title-right"></div>
        </div>
        <div class="dataOverview-echarts">
          <!-- <dataO></dataO> -->
          <pie></pie>
        </div>
      </div>

      <!--水位-->
      <div class="waterLevel">
        <div class="title-box">
          <div class="waterLevel-cont"></div>
          <div class="title">水位</div>
          <div class="title-right"></div>
        </div>
        <div class="waterLevel-echarts">
          <waterL></waterL>
        </div>
      </div>

      <!--水位 监控-->
      <div class="waterMonitor">
        <div class="title-box">
          <div class="waterMonitor-cont"></div>
          <div class="title">监控</div>
          <div class="title-right"></div>
        </div>
        <div class="monitor1">
          <div @click="spet(1)" :class="app == true ? 'mordde' : ''">园区</div>
          <div @click="spet(2)" :class="add == true ? 'mordde' : ''">设备</div>
        </div>
        <div v-show="app" class="monitor">
          <ul>
            <li
              @click="monitorShowt(item.address, item.id)"
              v-for="(item, index) in videoList"
              :key="index"
            >
              <videoP :m3u8url="item.address"></videoP>
            </li>
          </ul>
        </div>

        <div v-show="add" class="monitor">
          <ul>
            <li
              @click="monitorShowt(item.address,item.id)"
              v-for="(item, index) in equipmentVideoList"
              :key="index"
            >
              <videoP :m3u8url="item.address"></videoP>
            </li>
          </ul>
        </div>
        <div class="monitorShoww" v-show="this.$store.state.monitorShow">
          <monitortk
            v-if="this.$store.state.monitorShow"
          ></monitortk>
        </div>
      </div>
    </div>

    <div class="right" :class="this.$store.state.showContent ? 'right-a' : ''">
      <!--人员管理-->
      <div class="personnel">
        <div class="title-box">
          <div class="personnel-cont"></div>
          <div class="title">人员管理</div>
          <div class="title-right"></div>
        </div>
        <div class="personnel-top">
          <div>
            <div class="blue-people"></div>
            <span class="text">人员总数</span>
            <span class="num">1879</span>
          </div>
          <div>
            <div class="green-people"></div>
            <span class="text">在岗人数</span>
            <span class="num">1879</span>
          </div>
          <div>
            <div class="yellow-people"></div>
            <span class="text">离岗人数</span>
            <span class="num">1879</span>
          </div>
        </div>
        <div class="people-line"></div>
        <div class="people-form-title">
          <span>序号</span>
          <span>工号</span>
          <span>姓名</span>
          <span>是否在岗</span>
        </div>

        <div class="people-list">
          <ul>
            <li>01</li>
            <li>0011</li>
            <li>蒋民乐</li>
            <li>在岗</li>
          </ul>
          <ul>
            <li>01</li>
            <li>0011</li>
            <li>金波</li>
            <li>在岗</li>
          </ul>
          <ul>
            <li>01</li>
            <li>0011</li>
            <li>杨伟</li>
            <li>在岗</li>
          </ul>
          <ul>
            <li>01</li>
            <li>0011</li>
            <li>蒋民乐</li>
            <li>在岗</li>
          </ul>
          <ul>
            <li>01</li>
            <li>0011</li>
            <li>金波</li>
            <li>在岗</li>
          </ul>
          <ul>
            <li>01</li>
            <li>0011</li>
            <li>杨伟</li>
            <li>在岗</li>
          </ul>
          <ul>
            <li>01</li>
            <li>0011</li>
            <li>蒋民乐</li>
            <li>在岗</li>
          </ul>
          <ul>
            <li>01</li>
            <li>0011</li>
            <li>金波</li>
            <li>在岗</li>
          </ul>
          <ul>
            <li>01</li>
            <li>0011</li>
            <li>杨伟</li>
            <li>在岗</li>
          </ul>
        </div>
      </div>

      <!--设备信息-->
      <div class="EquipmentInformation">
        <div class="title-box">
          <div class="EquipmentInformation-cont"></div>
          <div class="title InformationT">现场设备工作信息</div>
          <div class="title-right InformationR"></div>
        </div>
        <div class="EquipmentInformation-form-title">
          <span>设备编号</span>
          <span>设备名字</span>
          <span>负责人</span>
          <span>设备状态</span>
        </div>
        <div class="EquipmentInformation-list">
          <ul>
            <li>1001</li>
            <el-tooltip
              effect="dark"
              class="item"
              content="JQH-1型雨量器"
              placement="top"
            >
              <li class="one">JQH-1型雨量器</li>
            </el-tooltip>

            <li>蒋民乐</li>
            <li>工作中</li>
          </ul>
          <ul>
            <li>1001</li>
            <el-tooltip
              effect="dark"
              class="item"
              content="JDZ05-1型雨量器"
              placement="top"
            >
              <li class="one">JDZ05-1型雨量器</li>
            </el-tooltip>
            <li>蒋民乐</li>
            <li>工作中</li>
          </ul>
          <ul>
            <li>1001</li>
            <el-tooltip
              effect="dark"
              class="item"
              content="TEZ-601全自动蒸发仪"
              placement="top"
            >
              <li class="one">TEZ-601全自动蒸发仪</li>
            </el-tooltip>
            <li>蒋民乐</li>
            <li>工作中</li>
          </ul>
          <ul>
            <li>1001</li>
            <el-tooltip
              effect="dark"
              class="item"
              content="E601型人工蒸发器"
              placement="top"
            >
              <li class="one">E601型人工蒸发器</li>
            </el-tooltip>
            <li>蒋民乐</li>
            <li>工作中</li>
          </ul>
          <ul>
            <li>1001</li>
            <el-tooltip
              effect="dark"
              class="item"
              content="YLN-YQS气泡式水位计"
              placement="top"
            >
              <li class="one">YLN-YQS气泡式水位计</li>
            </el-tooltip>
            <li>蒋民乐</li>
            <li>工作中</li>
          </ul>
          <ul>
            <li>1001</li>
            <el-tooltip
              effect="dark"
              class="item"
              content="WEISER WFX-40型数字水位计"
              placement="top"
            >
              <li class="one">WEISER WFX-40型数字水位计</li>
            </el-tooltip>
            <li>蒋民乐</li>
            <li>工作中</li>
          </ul>
          <ul>
            <li>1001</li>
            <el-tooltip
              effect="dark"
              class="item"
              content="HY-400型水文缆道绞车 （绞车发动机）"
              placement="top"
            >
              <li class="one">HY-400型水文缆道绞车 （绞车发动机）</li>
            </el-tooltip>
            <li>蒋民乐</li>
            <li>工作中</li>
          </ul>
          <ul>
            <li>1001</li>
            <el-tooltip
              effect="dark"
              class="item"
              content="TEL-12全自动双轨雷达波测流系统"
              placement="top"
            >
              <li class="one">TEL-12全自动双轨雷达波测流系统</li>
            </el-tooltip>
            <li>蒋民乐</li>
            <li>待机中</li>
          </ul>
          <ul>
            <li>1001</li>
            <el-tooltip
              effect="dark"
              class="item"
              content="HH-XLQ-05-K01型全自动缆道测流系统"
              placement="top"
            >
              <li class="one">HH-XLQ-05-K01型全自动缆道测流系统</li>
            </el-tooltip>
            <li>蒋民乐</li>
            <li>待机中</li>
          </ul>
          <ul>
            <li>1001</li>
            <el-tooltip
              effect="dark"
              class="item"
              content="JQH-1型雨量器"
              placement="top"
            >
              <li class="one">JQH-1型雨量器</li>
            </el-tooltip>
            <li>蒋民乐</li>
            <li>工作中</li>
          </ul>
          <ul>
            <li>1001</li>
            <el-tooltip
              effect="dark"
              class="item"
              content="JDZ05-1型雨量器"
              placement="top"
            >
              <li class="one">JDZ05-1型雨量器</li>
            </el-tooltip>
            <li>蒋民乐</li>
            <li>工作中</li>
          </ul>
        </div>
        <!-- <div class="more">更多信息</div> -->
      </div>

      <!--告警信息-->
      <div class="warning">
        <div class="title-box">
          <div class="warning-cont"></div>
          <div class="title">告警信息</div>
          <div class="title-right"></div>
        </div>
        <div class="warning-from-title">
          <span>告警编号</span>
          <span>告警来源</span>
          <span>告警状态</span>
        </div>
        <div class="warning-list">
          <ul>
            <li>1201</li>
            <li>摄像头1</li>
            <li>告警状态</li>
          </ul>
          <ul>
            <li>1202</li>
            <li>漂浮物监控</li>
            <li class="red">漂浮物侵入</li>
          </ul>
          <ul>
            <li>1203</li>
            <li>水位</li>
            <li>警戒水位</li>
          </ul>
          <ul>
            <li>1204</li>
            <li>环控</li>
            <li>烟雾</li>
          </ul>
          <ul>
            <li>1205</li>
            <li>摄像头2</li>
            <li>起火</li>
          </ul>
          <div class="amhru"></div>
        </div>
        <!-- <div class="more">更多信息</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import waterL from "../components/waterL";
import pie from "../components/pie";
import monitortk from "../components/monitortk"; // 点击监控组件
import videoP from "../components/videoP"; // 右下角 监控组件
import "videojs-contrib-hls"; // hls  视频流

export default {
  name: "home",
  data() {
    return {
      app: true,
      add: false,

      //园区监控
      videoList: [
        {
          id: 1,
          // address: "http://127.0.0.1:8083/stream/76563ca9-20bc-4354-bf95-0f6b21070fac/channel/0/hls/live/index.m3u8",
          address: "http://cctvalih5ca.v.myalicdn.com/live/cctv1_2/index.m3u8",
        },
        {
          id: 2,
          address: "http://cctvalih5ca.v.myalicdn.com/live/cctv2_2/index.m3u8",
        },
        {
          id: 3,
          address: "http://cctvalih5ca.v.myalicdn.com/live/cctv1_2/index.m3u8",
        },
        {
          id: 4,
          address: "http://cctvalih5ca.v.myalicdn.com/live/cctv2_2/index.m3u8",
        },
      ],
      //设备监控
      equipmentVideoList: [
        {
          id: 5,
          address: "http://cctvalih5ca.v.myalicdn.com/live/cctv1_2/index.m3u8",
        },
        {
          id: 6,
          address: "http://cctvalih5ca.v.myalicdn.com/live/cctv2_2/index.m3u8",
        },
      ],
    };
  },
  components: {
    waterL,
    pie,
    monitortk,
    videoP,
  },
  mounted() {
    window.tk = this.tk;
  },
  methods: {
    spet(val) {
      switch (val) {
        case 1:
          this.app = true;
          this.add = false;
          break;
        case 2:
          this.add = true;
          this.app = false;
          break;
      }
    },
    initVideoPlayer() {},
    monitorShowt(i, k) {
      this.$store.state.monitorShow = !this.$store.state.monitorShow;
      this.$store.state.monitorUrl = i;
      this.$store.state.monitorId = k;
    //  console.log(k, 555);
    },
    tk(t) { //三维点击 传入 id
    //  console.log(t,666)
      for (var i = 0; i < this.videoList.length; i++) {
        if (this.videoList[i].id == t) {
          this.$store.state.monitorShow = true; //视频弹框 显示隐藏
          this.$store.state.monitorUrl = this.videoList[i].address;
        }
      }
        for (var j = 0; j < this.equipmentVideoList.length; j++) {
        if (this.equipmentVideoList[j].id == t) {
          this.$store.state.monitorShow = true; //视频弹框 显示隐藏
          this.$store.state.monitorUrl = this.equipmentVideoList[j].address;
        }
      }
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style scoped>
.left {
  position: absolute;
  /*left: 4%;*/
  top: 6.4%;
  width: 19.5%;
  height: 91.5%;
  /* background: url('../assets/leftBg.png'); */
  background: rgba(34, 50, 70, 0.5);
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
  /* opacity: 0; */
  transition: all 1s;
  z-index: 9;
  transform: translateX(-100%);
}

.left-a {
  width: -19.5%;
  /* opacity: 1; */
  transition: all 1s;
  transform: translateX(0);
}

.right {
  position: absolute;
  top: 6.4%;
  right: 0;
  width: 19.5%;
  height: 91.5%;
  /* background: url('../assets/leftBg.png'); */
  background: rgba(34, 50, 70, 0.5);
  /* display: flex; */
  align-content: space-between;
  flex-wrap: wrap;
  z-index: 9;
  transition: all 1s;
  transform: translateX(100%);
}

.right-a {
  width: -19.5%;
  transition: all 1s;
  transform: translateX(0);
}
/* 环境信息 */
.environmental {
  width: 96%;
  height: 16%;
  margin-left: 2.5%;
  margin-top: 0.88vh;
  float: left;
}

.title-box {
  width: 18vw;
  height: 1.94vh;
  position: relative;
}

.environmental-cont {
  width: 1.2vw;
  height: 1.94vh;
  background: url("../assets/img/environmental-cont.png") no-repeat;
  background-size: 100% 100%;
  float: left;
}
.title {
  width: 6.6vw;
  height: 2vh;
  margin-left: 0.35vw;
  font-size: 0.88vw;
  line-height: 2vh;
  background-image: -webkit-linear-gradient(bottom, #4ca1ff, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: SOURCEHANSANSCN-REGULAR;
  float: left;
}

.title-right {
  width: 5vw;
  height: 0.9vh;
  background: url("../assets/img/titleright1.png") no-repeat;
  float: left;
  margin-top: 0.9vh;
  margin-left: 4.8vw;
}
.amhru::after {
  content: "";
  position: absolute;
  width: 18.5vw;
  height: 0.6vh;
  left: 10px;
  top: 73.4vh;
  background: url("../assets/img/titleBottom.png") no-repeat;
  background-size: 100% 100%;
}
/* .title-right::after{
    content: "";
  position: absolute;
  width: 18.5vw;
  height: 0.6vh;
  left: 0;
  top: 20.2vh;
  background: url("../assets/img/titleBottom.png") no-repeat;
  background-size: 100% 100%;
} */
.InformationT {
  width: 7.5vw;
}
.InformationR {
  margin-left: 3.8vw;
}

.title-box::after {
  content: "";
  position: absolute;
  width: 18.5vw;
  height: 0.6vh;
  left: 0;
  top: 2.2vh;
  background: url("../assets/img/titleBottom.png") no-repeat;
  background-size: 100% 100%;
}
.time-box {
  width: 17.5vw;
  height: 2vh;
  font-size: 0.7vw;
  display: flex;
  justify-content: space-between;
  margin-top: 0.9vh;
  border-bottom: 2px solid #6a737f;
}
.time-box div:nth-child(1) {
  width: 5vw;
  text-align: start;
}
.time-box div:nth-child(3) {
  width: 8vw;
  text-align: center;
}
.time-box div:nth-child(5) {
  width: 3.8vw;
  text-align: end;
}

.time-box .line {
  width: 1px;
  height: 1.8vh;
  background: #6a737f;
  margin-bottom: 1vh;
}

.weather {
  width: 18vw;
  height: 11vh;
  float: left;
}
.rain {
  width: 5.15vw;
  height: 10vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  float: left;
}

.rain div:nth-child(1) {
  width: 1.9vw;
  height: 3.4vh;
  background: url("../assets/img/rain.png");
}
.rain div:nth-child(2) {
  font-size: 0.7vw;
  margin-top: 1vh;
}
.rain div:nth-child(3) {
  font-size: 0.7vw;
  margin-top: 0.8vh;
}

.rain-line {
  width: 1px;
  height: 9vh;
  background: #6a737f;
  float: left;
  margin-top: 0.3vh;
}

.rain-right {
  width: 12.6vw;
  height: 10vh;
  float: left;
}
.rain-right ul {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.rain-right ul li {
  width: 5.6vw;
  height: 4.5vh;
  background: url("../assets/img/weaterbg.png");
  margin: 0.4vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 0.6vw;
}
.rain-right ul li span:nth-child(1) {
  color: #a5d0ff;
}

/* 数据概览 */
.dataOverview {
  width: 96%;
  height: 27%;
  margin-left: 2.5%;
  float: left;
}

.dataOverview-cont {
  width: 1.2vw;
  height: 1.94vh;
  background: url("../assets/img/dataOverview-icon.png") no-repeat;
  background-size: 100% 100%;
  float: left;
}
.dataOverview-echarts {
  width: 18vw;
  height: 24.5vh;
}

/* 水位 */
.waterLevel {
  width: 96%;
  height: 24%;
  margin-left: 2.5%;
  float: left;
}

.waterLevel-cont {
  width: 1.2vw;
  height: 1.94vh;
  background: url("../assets/img/waterLevel-icon.png") no-repeat;
  background-size: 100% 100%;
  float: left;
}

.waterLevel-echarts {
  width: 18vw;
  height: 20vh;
  margin-top: 2vh;
}

/* 水位 监控 */
.waterMonitor {
  width: 96%;
  height: 29%;
  margin-left: 2.5%;
  float: left;
}

.waterMonitor-cont {
  width: 1.2vw;
  height: 1.94vh;
  background: url("../assets/img/video12.png") no-repeat;
  background-size: 100% 100%;
  float: left;
}
.monitor {
  width: 18.5vw;
  height: 17vh;
}

.monitor ul {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.monitor ul li {
  width: 8.6vw;
  /* background:url('../assets/img/video.png');
 background-size:100% 100% ; */
  cursor: pointer;
}
.monitorShoww {
  position: absolute;
  left: 27.5vw;
  top: 22.4vh;
  width: 47vw;
  height: 54vh;
}
.waterMonitor ul li:nth-child(1) {
  margin-top: 0.6vh;
}
.waterMonitor ul li:nth-child(2) {
  margin-top: 0.6vh;
}

.waterMonitor ul li:nth-child(3) {
  margin-top: 0.7vh;
}
.waterMonitor ul li:nth-child(4) {
  margin-top: 0.7vh;
}
/* 人员管理 */
.personnel {
  margin-top: 0.88vh;
  margin-left: 2.5%;
  width: 96%;
  height: 24%;
}
.personnel-cont {
  width: 1.2vw;
  height: 1.94vh;
  background: url("../assets/img/people-icon.png") no-repeat;
  background-size: 100% 100%;
  float: left;
}
.personnel-top {
  width: 100%;
  height: 5vh;
  margin-top: 0.9vh;

  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.6vw;
  text-indent: 0.2vw;
  float: left;
}
.personnel-top div .blue-people {
  width: 2.1vw;
  height: 3.88vh;
  background: url("../assets/img/bule-people.png");
  background-size: 100% 100%;
  float: left;
}

.personnel-top div .green-people {
  width: 2.1vw;
  height: 3.88vh;
  background: url("../assets/img/green-people.png");
  background-size: 100% 100%;
  float: left;
}

.personnel-top div .yellow-people {
  width: 2.1vw;
  height: 3.88vh;
  background: url("../assets/img/yellow-people.png");
  background-size: 100% 100%;
  float: left;
}
.personnel-top div {
  width: 6.2vw;
}
.personnel-top div .text {
  width: 3.8vw;
  height: 1.7vh;
  float: left;
  background: url("../assets/img/text.png");
  margin-left: 0.1vw;
  line-height: 1.7vh;
  color: #b2b6c8;
}
.personnel-top div .num {
  width: 3.8vw;
  height: 2vh;
  float: left;
  background: url("../assets/img/num.png");
  margin-left: 0.1vw;
  margin-top: 0.2vh;
  line-height: 2vh;
}

.people-line {
  width: 100%;
  height: 0px;
  border: 1px dashed #708ba8;
  float: left;
}

.people-form-title {
  width: 96%;
  height: 2vh;
  font-size: 0.6vw;
  color: #73abd1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.people-form-title span:nth-child(1) {
  margin-left: 0.5vw;
}
.people-form-title span:nth-child(2) {
  margin-left: 0.5vw;
}
.people-form-title span:nth-child(3) {
  margin-left: 0.5vw;
}
.people-form-title span:nth-child(4) {
  margin-right: 0.8vw;
}
.people-form-title::after {
  content: "";
  position: absolute;
  margin-top: 2.5vh;
  width: 96%;
  height: 0.3vh;
  background: url("../assets/img/people-line.png");
}

.people-list {
  width: 100%;
  height: 11vh;
  margin-top: 0.5vh;
  overflow: auto;
}
.people-list ul {
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.5vw;
  color: #cbcfd3;
}
.people-list ul li:nth-child(1) {
  margin-left: 0.8vw;
}
.people-list ul li:nth-child(2) {
  width: 10%;
  margin-left: 1.6vw;
}
.people-list ul li:nth-child(3) {
  width: 14%;
  margin-left: 0.7vw;
}

.people-list ul li:nth-child(4) {
  margin-right: 2.1vw;
  color: #02cde5;
}

.people-list ul li.li {
  color: #e4b409;
}
.people-list::-webkit-scrollbar {
  width: 0.2vw;
}
.people-list::-webkit-scrollbar-thumb {
  width: 0.2vw;
  background: #b4d8ff;
}
.people-list::after {
  content: "";
  position: absolute;
  top: 22.5vh;
  width: 96%;
  height: 0.3vh;
  background: url("../assets/img/people-line.png");
}

/* 现场设备工作信息 */
.EquipmentInformation {
  width: 96%;
  height: 45%;
  margin-left: 2.5%;
  margin-top: 1.5vh;
}

.EquipmentInformation-cont {
  width: 1.2vw;
  height: 1.94vh;
  background: url("../assets/img/EquipmentInformation-icon.png") no-repeat;
  background-size: 100% 100%;
  float: left;
}
.EquipmentInformation-form-title {
  width: 96%;
  height: 2vh;
  font-size: 0.6vw;
  color: #73abd1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1vh;
}
.EquipmentInformation-form-title span:nth-child(1) {
  margin-left: 0.5vw;
}
.EquipmentInformation-form-title span:nth-child(4) {
  margin-right: 0.8vw;
}

.EquipmentInformation-form-title::after {
  content: "";
  position: absolute;
  top: 29.5vh;
  width: 96%;
  height: 0.3vh;
  background: url("../assets/img/people-line.png");
}
.EquipmentInformation-list {
  width: 100%;
  height: 36.5vh;
  /* overflow: auto; */
  margin-top: 1vh;
}
.EquipmentInformation-list ul {
  width: 100%;
  height: 3.23vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.EquipmentInformation-list ul:nth-child(odd) {
  background: url("../assets/img/listbg.png");
}

.EquipmentInformation-list ul li {
  width: 20%;
  color: #cbcfd3;
  font-size: 0.6vw;
}
.EquipmentInformation-list ul li:nth-child(1) {
  width: 14%;
  margin-left: 0.9vw;
}
.EquipmentInformation-list ul li:nth-child(2) {
  width: 27%;
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
  line-height: 285%;
}
/* .one {
  overflow: hidden;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 1; 
-webkit-box-orient: vertical;
} */

.EquipmentInformation-list ul li:nth-child(3) {
  margin-right: 0.2vw;
  width: 16%;
}
.EquipmentInformation-list ul li:nth-child(4) {
  width: 17%;
  margin-right: 0.8vw;
  color: #06b2c8;
}

.EquipmentInformation-list::after {
  content: "";
  position: absolute;
  top: 66.4vh;
  width: 96%;
  height: 0.3vh;
  background: url("../assets/img/people-line.png");
}
.more {
  width: 5vw;
  height: 2vh;
  /* border: 1px solid red; */
  font-size: 0.7vw;
  text-align: center;
  margin-left: 13vw;
  margin-top: 0.4vh;
  background: url("../assets/img/more-jiantou.png") no-repeat 4.1vw 0.7vh;
  cursor: pointer;
}

/* 告警信息 */
.warning {
  width: 96%;
  height: 23%;
  margin-left: 2.5%;
  margin-top: 3.5vh;
}
.warning-cont {
  width: 1.2vw;
  height: 1.94vh;
  background: url("../assets/img/warning-icon.png") no-repeat;
  background-size: 100% 100%;
  float: left;
}
.warning-from-title {
  width: 96%;
  height: 2vh;
  font-size: 0.6vw;
  color: #73abd1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.7vh;
}
.warning-from-title span:nth-child(1) {
  margin-left: 0.5vw;
}
.warning-from-title span:nth-child(3) {
  margin-right: 0.8vw;
}

.warning-from-title::after {
  content: "";
  position: absolute;
  top: 88.4vh;
  width: 96%;
  height: 0.3vh;
  background: url("../assets/img/people-line.png");
}
.warning-list {
  width: 100%;
  height: 10vh;
  margin-top: 0.8vh;
}
.warning-list ul {
  width: 100%;
  height: 3.23vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.warning-list ul:nth-child(odd) {
  background: url("../assets/img/listbg.png");
  height: 2.35vh;
}

.warning-list ul li {
  width: 20%;
  color: #cbcfd3;
  font-size: 0.6vw;
}
.warning-list ul li:nth-child(1) {
  margin-left: 1vw;
}
.warning-list ul li:nth-child(3) {
  margin-right: 0.3vw;
  color: #c1a519;
}
.warning-list ul li.red {
  color: red;
}
.warning-list::after {
  content: "";
  position: absolute;
  top: 66.3vh;
  width: 96%;
  height: 0.3vh;
  background: url("../assets/img/people-line.png");
}
.warning .more {
  margin-top: 2.5vw;
}

/*设备操控 */
.Equipment {
  width: 96%;
  height: 25%;

  margin-left: 2.5%;
}
.Equipment-cont {
  width: 1.2vw;
  height: 1.94vh;
  background: url("../assets/img/Equipment.png") no-repeat;
  background-size: 100% 100%;
  float: left;
}
.Equipment-form-title {
  width: 96%;
  height: 2vh;
  font-size: 0.6vw;
  color: #73abd1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.7vh;
}
.Equipment-title span:nth-child(1) {
  margin-left: 0.8vw;
}
.Equipment-form-title span:nth-child(3) {
  margin-right: 0.5vw;
}
.Equipment-form-title span:nth-child(4) {
  margin-right: 1.4vw;
}
.Equipment-form-title::after {
  content: "";
  position: absolute;
  top: 73.5vh;
  width: 96%;
  height: 0.3vh;
  background: url("../assets/img/people-line.png");
}
.Equipment-list {
  width: 100%;
  height: 10vh;
  margin-top: 1vh;
}
.Equipment-list ul {
  width: 100%;
  height: 3.23vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Equipment-list ul:nth-child(odd) {
  background: url("../assets/img/listbg.png");
  height: 2.35vh;
}

.Equipment-list ul li {
  width: 20%;
  color: #cbcfd3;
  font-size: 0.6vw;
}
.Equipment-list ul li:nth-child(1) {
  margin-left: 1vw;
}
.Equipment-list ul li:nth-child(3) {
  margin-left: 0.5vw;
}
.Equipment-list ul li:nth-child(4) {
  margin-right: 0.3vw;
  color: #06b2c8;
}

.Equipment-list ul li.red {
  color: red;
}
.Equipment-list::after {
  content: "";
  position: absolute;
  top: 88.4vh;
  width: 96%;
  height: 0.3vh;
  background: url("../assets/img/people-line.png");
}
.Equipment .more {
  margin-top: 2.5vw;
}

.more:hover {
  background: url("../assets/img/morebg1.png");
}
.monitor1 {
  margin-top: 1vh;
  display: flex;
  height: 10%;
  background-color: rgba(34, 50, 70, 0.5);
}
.monitor1 div {
  display: flex;
  width: 50%;

  color: #ffffff;
  align-items: center;
  justify-content: center;
  font-size: 0.5vw;
}
.mordde {
  background-color: blue;
}
</style>


